import React from 'react';
import { FolderItem } from '../shared/FolderItem';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Svg from '../shared/Svg';
import { setSelectedFiles } from '../../actions/files';
import { useState } from 'react';
import { getObjectType } from '../../utils/typeMap';
import { PlusSign } from '../shared/PlusSign';
import './NavigateFile.scss';

export const NavigateFile = ({ file }) => {
  const dispatch = useDispatch();
  const selectedFiles = useSelector((state) => state.files.selectedFiles);
  const toggleOn = useSelector((state) => !!state.files.selectedFiles[file.Id]);
  const fileName = file.Name;
  const [itemHover, setItemHover] = useState(false);
  const imgSrc = getObjectType(file.Name.split('.').pop()).icon;
  const user = useSelector((state) => state.auth.user);
  const docrioNamespace = useSelector((state) => state.mail.settings?.override?.docrioNamespace || 'litify_docs');

  const handleToggle = () => {
    const newSelectedFiles = { ...selectedFiles };
    !toggleOn ? newSelectedFiles[file.Id] = { name: file.Name, folderPath: JSON.parse(file[`${docrioNamespace}__Folder_Path__c`]).join('/'), size: file[`${docrioNamespace}__File_Size__c`] } : delete newSelectedFiles[file.Id];
    dispatch(setSelectedFiles(newSelectedFiles));
  };

  return (
    <div id={file.Id} onMouseEnter={() => setItemHover(true)} onMouseLeave={() => setItemHover(false)}>
      <FolderItem image={<Svg data={imgSrc} className='navigate-file-image' />}
        content={<p className='navigate-file-content'>{fileName}</p>}
        button={<PlusSign clickAction={handleToggle} selectedState={toggleOn} isHoveringParent={itemHover} />}
        className={'navigate-file-container'}
        popoutLink={`${user.salesforceInstanceUrl}/lightning/n/${docrioNamespace}__File_Details?c__id=${file.Id}`}/>
    </div>
  );
};

NavigateFile.propTypes = {
  file: PropTypes.object.isRequired,
};

